import { Editor, Element, Node, Path, Range } from 'slate';
import { getBlockTagIds } from 'slate/extensions/tag/types/block';

export interface BlockCarrier {
  path: Path;
  elementId: string;
}

export interface BlockSelection {
  kind: 'image' | 'table' | 'paragraph' | 'list';
  path: Path;
  elementId: string;
}

export function selectionBlockCarrier(blockSelection: BlockSelection | null, blockScope: string | undefined): BlockCarrier | null {
  if (!blockSelection) return null;
  const { kind, path, elementId } = blockSelection;
  if (kind === 'image') return { path, elementId };
  if ((kind === 'paragraph' || kind === 'list') && blockScope === 'block') return { path, elementId };
  return null;
}

export function carrierHoldsAnyTag(editor: Editor, path: Path, tagIds: string[]): boolean {
  if (tagIds.length === 0) return false;
  const wanted = new Set(tagIds);
  try {
    for (const [node] of Node.nodes(Node.get(editor, path))) {
      if (!Element.isElement(node)) continue;
      if (getBlockTagIds(node).some((id) => wanted.has(id))) return true;
      if (node.type === 'tag' && wanted.has((node as { tagId?: string }).tagId ?? '')) return true;
    }
    return false;
  } catch {
    return false;
  }
}

export function listItemsRange(editor: Editor, range: Range): Range | null {
  const items = Array.from(Editor.nodes(editor, { at: range, match: (n) => Element.isElement(n) && n.type === 'list-item' }));
  if (items.length === 0) return null;
  return { anchor: Editor.start(editor, items[0][1]), focus: Editor.end(editor, items[items.length - 1][1]) };
}
